/**
 * @generated SignedSource<<9f95ee81192372d85a1191849c23e3da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedListedContent_viewer$data = {
  readonly showHeartCount: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_viewer" | "PdpSharedCondensedSidebarButtons_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedShippingBadge_viewer">;
  readonly " $fragmentType": "PdpRespCondensedListedContent_viewer";
};
export type PdpRespCondensedListedContent_viewer$key = {
  readonly " $data"?: PdpRespCondensedListedContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedListedContent_viewer",
  "selections": [
    {
      "alias": "showHeartCount",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpDisplayHeartCount"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpDisplayHeartCount\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCondensedSidebarButtons_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0f3cf0f089772b33dc178c2e982f2a28";

export default node;
